<script setup>
// import SettingsTheme from '../components/SettingsTheme.vue'
// import SettingsCalendarSetup from '../components/SettingsCalendarSetup.vue';
// import SettingsCalendarSettings from "../components/SettingsCalendarSettings.vue";

import RegisterScreen from '../components/RegisterScreen.vue';
// SettingsTheme.loadTheme()
</script>

<template>
  <div class="register">
    <div class="mx-auto max-w-6xl">
      <div class="flex flex-wrap justify-between" >
        <div class="w-4/12">
          <h1 class="separator-center mb-2 leading-normal text-2xl">Create Account</h1>
        </div>
        <div class="w-4/12"><RouterLink class="btn btn-primary float-right" to="/">Back to Home</RouterLink></div>
      </div>
        
        
      </div>
      <RegisterScreen></RegisterScreen>

  </div>
</template>